import { IMobileActionsInjectable } from '../../core/interface';
import BaseActionsInjectable from '../base/actions-injectable';

export default class MobileActionsInjectable extends BaseActionsInjectable implements IMobileActionsInjectable {

}
